import { ChangeEvent } from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Checkbox,
  FormGroup
} from "@material-ui/core";

type Option = {
  label: string;
  value: string;
};

export type CheckboxGroupProps = {
  name?: string;
  value: string[];
  onChange: (event: ChangeEvent<HTMLInputElement>, value: string[]) => void;
  options: Option[];
  label?: string;
  helperText?: string;
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
};

export function CheckboxGroup(props: CheckboxGroupProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.name;
    const checked = event.target.checked;

    if (checked) {
      props.onChange(event, [...props.value, value]);
    } else {
      props.onChange(
        event,
        props.value.filter((v) => v !== value)
      );
    }
  };

  return (
    <FormControl
      disabled={props.disabled}
      error={props.error}
      required={props.required}
      variant="outlined"
    >
      {props.label && (
        <InputLabel
          htmlFor={props.name}
          required={props.required}
          error={props.error}
          shrink={true}
        >
          {props.label}
        </InputLabel>
      )}

      <FormGroup onChange={handleChange}>
        {props.options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={true}
            checked={props.value.includes(option.value)}
            control={<Checkbox size="small" />}
            label={option.label}
            name={option.value}
          />
        ))}
      </FormGroup>

      {props.helperText && (
        <FormHelperText error={props.error}>{props.helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
